import { Component } from '@angular/core';

@Component({
  selector: 'app-br-loading',
  templateUrl: './loading.component.html'
})
export class BrLoadingComponent { }
